import dayjs from "dayjs";

import { Translation } from "@/data/lang";

export type DateOption =
  | `${"1" | "2" | "3" | "4" | "5" | "6" | "7" | "8" | "9" | "10"}${"M" | "Y"}`
  | "All"
  | "YTD";

export const allDateOptions: DateOption[] = [
  "1M",
  "3M",
  "6M",
  "1Y",
  "3Y",
  "All",
];

export const yearDateOptions: DateOption[] = ["1Y", "3Y", "5Y", "YTD", "All"];

export const historicalSignalsOptions: DateOption[] = [
  "1Y",
  "3Y",
  "5Y",
  "YTD",
  "All",
];

export const getFirstDate = (option: DateOption) => {
  if (option === "YTD") return dayjs().startOf("year").format("YYYY-MM-DD");
  if (option === "All") return "2007-01-01";
  const number = +option.slice(0, -1);
  const unit = option.slice(-1) === "M" ? "month" : "year";
  return dayjs().subtract(number, unit).format("YYYY-MM-DD");
};

export const getDateOptionsToTextMap = ({
  t,
}: {
  t: Translation;
}): Partial<Record<DateOption, string>> => ({
  YTD: t.analysis.shared.dateOption.ytd,
  All: t.analysis.shared.dateOption.all,
});

export const getTextToDateOptionMap = ({
  t,
}: {
  t: Translation;
}): Record<string, DateOption> => ({
  [t.analysis.shared.dateOption.ytd]: "YTD",
  [t.analysis.shared.dateOption.all]: "All",
});

export const getDisplayDateOptions = ({
  t,
  options,
}: {
  t: Translation;
  options: DateOption[];
}) => {
  const textMap = getDateOptionsToTextMap({ t });
  return options.map((option) => textMap[option] ?? option);
};
